module.exports = "\n<!-- <app-tabs-page></app-tabs-page> -->\n<router-outlet></router-outlet>\n"